export const GET_ALL_DIMENSIONS = profileId => `/admin/onboarding/profiles/${profileId}/dimensions`;
export const CREATE_BUDGET = '/admin/onboarding/profiles/createbudget';
export const GET_BUDGET_YEARS = '/admin/onboarding/profiles/budgetyears';
export const GET_GROWTH_RATES = '/admin/onboarding/profiles/getGrowthRate';
export const GET_GL_WRITEBACK_VERSIONS = planId => `/glwriteback/getGLWriteBackVersionMembers/${planId}`;
export const WRITEBACK_TO_GL = `/glwriteback/writeBackToGL`;
export const GET_GL_COMPANIES = `/glsettings/companies`;
export const COMPANY_DISCONNECT = `/glsettings/company/disconnect`;
export const COMPANY_RECONNECT = `/glsettings/company/reconnect`;
export const ACCOUNT_SETUP_STATUS = '/admin/onboarding/accountsetup/progress';

export const GET_WEBHOOK_QUEUE_LOGS = '/admin/webhooklogqueue/get-webhook-logs';
export const GET_WEBHOOK_QUEUE_LOG_INFO = webhookLogId => `/admin/webhooklogqueue/get-qbo-webhook-log-info/${webhookLogId}`;
export const PERFORM_ACTION_WEBHOOK_QUEUE_LOG = '/admin/webhooklogqueue/perform-action-webhook-log-queue-items';

export const GET_WEBHOOK_ACCT_NOTIFICATIONS = '/admin/webhookAccountNotification/get-webhook-acctnotifications';
export const GET_WEBHOOK_ACCT_NOTIFICATION_INFO = webhookAcctNotificationId =>
  `/admin/webhookAccountNotification/get-qbo-webhook-acctnotification-info/${webhookAcctNotificationId}`;
export const PERFORM_ACTION_WEBHOOK_ACCT_NOTIFICATION = '/admin/webhookAccountNotification/perform-action-webhook-acctnotification-items';

export const GET_FORECAST_ACTUALS_VERSIONS = planId => `/forecasts/actual-versions/${planId}`;
export const GET_FORECAST_BUDGET_VERSIONS = planId => `/forecasts/budget-versions/${planId}`;
export const GET_FORECAST_ACTUALS_END_PERIODS = (planId, forecastDefinitionId) => `/forecasts/actual-end-periods/${planId}/${forecastDefinitionId}`;
export const GET_PLAN_VERSION = planId => `/dimension/plan-version/${planId}`;
export const POST_FORECAST = '/forecasts/versions';
export const UPDATE_FORECAST = `/forecasts/update-forecast`;

export const AUTOMATED_ONBOARDING_PAGE = '/automatedOnboarding/automatedOnboardingCurrentPage';

export const TIME_DIMENSION_ONBOARDING = '/automatedOnboarding/fiscal-calendar';

export const ACCOUNT_GROUP_HIERARCHY = '/automatedOnboarding/accountGroupMapping';
export const ACCOUNT_MEMBER_LIST = '/automatedOnboarding/unmappedAccountNumbers';
export const AUTOMATED_ONBOARDING_INFO = accountId => `/automatedOnboarding/automatedOnboardingInfo/${accountId}`;

export const REVIEW_DATA_ONBOARDING = '/automatedOnboarding/review-data';
export const REVIEW_DATA_ONBOARDING_SEND_TO_SUPPORT = '/automatedOnboarding/review-data-send-support';

export const CREATE_BUDGET_ONBOARDING = '/automatedOnboarding/create-budget';

export const AUDIT_LOGS = (module, action, user, from, to, offset) =>
  `/auditlogs/find?module=${module}&action=${encodeURIComponent(action)}&userName=${user}&fromDate=${from}&toDate=${to}&timeZoneOffset=${offset}`;
export const ALL_MODULES = '/auditlogs/getModules';
export const ALL_USERS = '/users/list/all';
export const ALL_JOB_STATUSES = '/jobstatus/getJobStatus';
export const JOBS = (jobStatus, onlyMine) => `/jobstatus/find?jobStatus=${jobStatus}&onlyMine=${onlyMine}`;
export const GET_FAILED_JOB_REPORT = jobId => `/dpImportReport/download/${jobId}`;
export const LATEST_JOBS = (jobStatus, onlyMine) => `/latestPlanAndCubeJobStatus/find?jobStatus=${jobStatus}&onlyMine=${onlyMine}`;
export const LATEST_RELEASE_NOTES = '/releasenotes/latest';
export const CREATE_RELEASE_NOTES = '/releasenotes/new';
export const GET_SAMPLE_PLANS = '/api/tesseractplan/getSamplePlans/true';
export const GET_WHATS_NEW_CONFIG = '/api/homepage/widget/whatsNew/config';
export const GET_WHATS_NEW_FILE = filename => `/api/homepage/widget/whatsNew/downloadFile/${filename}`;
export const GET_CURRENT_PROFILE = '/api/openlink/connect-default-profile';
export const SET_SELECTED_PLAN = planName => `/api/tesseractplan/setSelectedPlan/${planName}`;
export const GET_TIME_DIMENSION = planId => `/copyversion/getTimeDimension/${planId}`;
export const GET_PERIOD_INFO = '/copyversion/getPeriodInfo';
export const GET_VERSION_MEMBER_INFO = planId => `/version/versionMemberInfoStatus?planId=${planId}`;
export const CHECK_VERSION_LOCK_STATUS = (planId, versionId) => `/version/checkVersionDimensionLockStatus?planId=${planId}&versionId=${versionId}`;
export const LOCK_MEMBER = `/version/lockMember`;
export const CHECK_VERSION_DELETE_STATUS = (planId, versionId) =>
  `/version/checkVersionDimensionDeleteStatus?planId=${planId}&versionId=${versionId}`;
export const DELETE_BUDGET_VERSION_MEMBER = `/version/deleteBudgetVersion`;

export const GET_QUICKLINKS = `/quicklinks/getQuickLinksForUser`;
export const UPDATE_QUICKLINKS = `/quicklinks/save`;

export const GET_REPORTS = planId => `/tesseractplan/report/ALL/${planId}`;
export const POST_FAVORITE_REPORT = `tesseractplan/report/favorite`;
export const POST_DELETE_REPORT = `tesseractplan/view/delete`;
export const POST_COPY_REPORT = `tesseractplan/view/copy`;

export const GET_LAST_CIF = profileId => `/cif/getLastCIFUploadTimeForProfile/${profileId}`;
export const GET_ASSIGNMENTS = planId => `/budgetworkflow/getWorkflowWidgetTasks/${planId}`;
export const SUBMIT_ASSIGNMENT = `/workflow/processWorkflow`;
export const GET_WORKFLOW_STATUS = planId => `/budgetworkflow/getWorkflowEnableStatus/${planId}`;
